//material ui imports
import { withStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import { FormGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import Accordion from '@material-ui/core/Accordion';
import { Translate } from '@material-ui/icons';

//OUTLINED INPUT
const CustomOutlinedInput = withStyles({
  root: {
    padding: '0 10px',
    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#fa0171',
      },
      '&:hover fieldset': {
        borderColor: '#38d611',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#38d611',
      },
    },
  },
})(OutlinedInput);

export const MyOutlinedInput = ({
  value,
  onChange,
  state,
  label,
  fullWidth,
  id,
  endAdornment,
  helperText,
}) => {
  return (
    <FormControl fullWidth={fullWidth} variant='outlined'>
      <InputLabel
        htmlFor={id}
        style={{
          color: state.theme === 'dark' ? '#fff' : '#00152b',
          fontWeight: '100',
          fontFamily: '"Alegreya Sans", sans-serif',
          fontSize: '18px',
        }}
      >
        {label}
      </InputLabel>
      <CustomOutlinedInput
        id={id}
        label={label}
        endAdornment={
          endAdornment ? (
            <InputAdornment
              className={
                state.theme === 'dark'
                  ? 'clusterNameAdornmentDark'
                  : 'clusterNameAdornmentLight'
              }
              position='end'
            >
              {endAdornment}
            </InputAdornment>
          ) : null
        }
        value={value}
        onChange={onChange}
        style={{
          color: state.theme === 'dark' ? '#fff' : '#00152b',
          fontFamily: '"Alegreya Sans", sans-serif',
          fontSize: '18px',
        }}
      />
      {helperText ? (
        <FormHelperText
          style={{
            color: state.theme === 'dark' ? '#fff' : '#00152b',
            fontFamily: '"Alegreya Sans", sans-serif',
          }}
        >
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};

//OUTLINED INPUT WITH BUTTON
const CustomOutlinedInputWithButton = withStyles({
  root: {
    padding: '0 10px',

    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#0075ba',
      },
      '&:hover fieldset': {
        borderColor: '#0075ba',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#0075ba',
      },
    },
  },
})(OutlinedInput);

const connectToWeaviateButton = makeStyles({
  root: {
    color: '#fff',
    fontFamily: '"Alegreya Sans", sans-serif',
    fontSize: '14px',
    background: '#BB0973',
    height: '40px',

    '&:hover': {
      background: '#95025c !important',
    },
  },
});

export const MyOutlinedInputWithButton = ({
  value,
  onChange,
  state,
  label,
  fullWidth,
  id,
  endAdornmentOnClick,
  endAdornmentLabel,
  endAdornmentId,
  helperText,
  helperTextId,
  placeholder,
}) => {
  const classes = connectToWeaviateButton();
  return (
    <FormControl fullWidth={fullWidth} variant='outlined'>
      <InputLabel
        htmlFor={id}
        style={{
          color: '#fff',
          fontWeight: '100',
          fontFamily: '"Alegreya Sans", sans-serif',
          fontSize: '18px',
        }}
      >
        {label}
      </InputLabel>
      <CustomOutlinedInputWithButton
        id={id}
        label={label}
        placeholder={placeholder}
        endAdornment={
          <Button
            style={{ padding: state.isLoginLoading ? '5px 22px' : '5px 30px' }}
            id={endAdornmentId}
            className={classes.root}
            onClick={endAdornmentOnClick}
          >
            {endAdornmentLabel}
          </Button>
        }
        value={value}
        onChange={onChange}
        style={{
          color: '#fff',
          fontFamily: '"Alegreya Sans", sans-serif',
          fontSize: '18px',
        }}
      />
      {helperText ? (
        <FormHelperText
          style={{
            color: state.isLogInSelfHostedIncorrect ? '#fa0171' : '#fff',
            fontFamily: '"Alegreya Sans", sans-serif',
          }}
          id={helperTextId}
        >
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};

//Input with action button inside of it
const CustomInputWithButton = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#fa0171',
    },
    width: '98%',
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fa0171',
    },
    '&::placeholder ': {
      fontFamily: '"Alegreya Sans", sans-serif',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#fa0171',
      },
      '&:hover fieldset': {
        borderColor: '#fa0171',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fa0171',
      },
      '&:placeholder fieldset': {
        fontFamily: '"Alegreya Sans", sans-serif',
      },
    },
  },
})(TextField);

export const MyInputWithButton = ({
  value,
  onChange,
  fullWidth,
  id,
  placeholder,
  endAdornmentOnClick,
  endAdornmentLabel,
  endAdornmentId,
}) => {
  return (
    <CustomInputWithButton
      fullWidth={fullWidth}
      id={id}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{
        color: '#00152b',
        fontFamily: '"Alegreya Sans", sans-serif',
        fontSize: '18px',
      }}
      InputProps={{
        endAdornment: (
          <Button
            id={endAdornmentId}
            style={{
              color: '#00152b',
              fontFamily: '"Alegreya Sans", sans-serif',
              fontSize: '17px',
            }}
            onClick={endAdornmentOnClick}
          >
            {endAdornmentLabel}
          </Button>
        ),
      }}
    />
  );
};

//RADIO
const radioUseStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    border: '2px solid #fa0171',
    width: 27,
    height: 27,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: 'transparent',
    '$root.Mui-focusVisible &': {
      outline: '4px auto rgba(19,124,189,.6)',
      outlineOffset: 1,
    },
    'input:hover ~ &': {
      border: '2px solid #95025c',
    },
  },
  checkedIcon: {
    backgroundColor: 'transparent',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 23,
      height: 23,
      backgroundImage: 'radial-gradient(#fa0171,#fa0171 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: 'transparent',
      border: '2px solid #95025c',
    },
  },
});

function CustomRadio(props) {
  const classes = radioUseStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color='default'
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

export const MyRadioComponent = ({
  value,
  onChange,
  options,
  state,
  labelPlacement,
  row,
  helperText,
}) => {
  return (
    <FormControl component='fieldset'>
      <RadioGroup row={row} value={value || 'sandbox'} onChange={onChange}>
        {options.map((o, idx) => (
          <div
            style={{ display: 'flex', position: 'relative', height: '58px' }}
            key={idx}
          >
            <FormControlLabel
              labelPlacement={labelPlacement}
              value={o.option}
              control={<CustomRadio />}
              label={
                <p
                  style={{
                    margin: '0 0px 0 0',
                    color: state.theme === 'dark' ? '#fff' : '#00152b',
                    fontFamily: '"Alegreya Sans", sans-serif',
                    fontSize: '20px',
                    textTransform: 'capitalize',
                  }}
                >
                  {o.name}
                </p>
              }
            />

            <small
              style={{
                color: state.theme === 'dark' ? '#ababab' : '#00152b',
                position: 'absolute',
                top: '40px',
                left: '36px',
              }}
            >
              {typeof o.price === 'number'
                ? `$${o.price}/hr`
                : o.price
                ? o.price
                : 'free'}
            </small>
          </div>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

//DROPDOWN
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(0),
    },
    width: '100%',
    background: 'transparent',
  },
  input: {
    color: 'fff',
    borderRadius: 4,
    width: '100%',
    position: 'relative',
    backgroundColor: 'transparent',
    border: '2px solid #122742',
    fontSize: 15,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: '"Alegreya Sans", sans-serif',
    '&:focus': {
      borderRadius: 4,
      borderColor: '#38d611',
      backgroundColor: 'transparent',
    },
  },
}))(InputBase);

const dropdownUseStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
    width: '74%',
  },
}));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    width: '100%',
    fontSize: '17px',
    margin: '0',
    '&:hover': {
      backgroundColor: '#fa0171 !important',
      color: '#fff !important',
    },
    '&:focus': {
      backgroundColor: '#fa0171 !important',
      color: '#fff !important',
    },
    fontFamily: '"Alegreya Sans", sans-serif',
  },
}))(MenuItem);

export const MyDropdownComponent = ({
  value,
  onChange,
  id,
  label,
  options,
  state,
}) => {
  const classes = dropdownUseStyles();

  return (
    <FormControl className={classes.margin}>
      <InputLabel
        style={{
          color: state.theme === 'dark' ? '#fff' : '#00152b',
          fontSize: '17px',
          width: '80%',
        }}
        id={id}
      >
        {label}
      </InputLabel>
      <Select
        MenuProps={{ disableScrollLock: true }}
        style={{
          color: state.theme === 'dark' ? '#fff' : '#00152b',
          fontFamily: '"Alegreya Sans", sans-serif',
          width: '80%',
        }}
        labelId={id}
        id={id}
        value={value}
        onChange={onChange}
        input={<BootstrapInput />}
      >
        {options
          ? options.map((o, idx) => (
              <StyledMenuItem key={idx} value={o.value}>
                {o.label}
              </StyledMenuItem>
            ))
          : null}
      </Select>
    </FormControl>
  );
};

//CHECKBOX

//smaller checkbox
const smallerCheckboxUseStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    border: '2px solid #fa0171',
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: 'transparent',

    '$root.Mui-focusVisible &': {
      outline: '4px auto rgba(19,124,189,.6)',
      outlineOffset: 1,
    },
    'input:hover ~ &': {
      border: '2px solid #95025c',
    },
  },
  checkedIcon: {
    backgroundColor: '#fa0171',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 14,
      height: 14,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#95025c',
    },
  },
  FormControlLabel: {
    flexWrap: 'breakWord',
  },
  checkboxFormControl: {
    marginTop: '5px',
  },
  Link: {
    fontSize: '15px',
    fontFamily: '"Alegreya Sans", sans-serif',
    color: '#fa0171',
    marginLeft: '5px',
    '&:hover': {
      color: '#95025c',
    },
  },
}));

//larger checkbox
const checkboxUseStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 27,
    height: 27,
    border: '2px solid #fa0171',
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: 'transparent',

    '$root.Mui-focusVisible &': {
      outline: '4px auto rgba(19,124,189,.6)',
      outlineOffset: 1,
    },
    'input:hover ~ &': {
      border: '2px solid #95025c',
    },
  },
  checkedIcon: {
    backgroundColor: '#fa0171',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 23,
      height: 23,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#95025c',
    },
  },
  FormControlLabel: {
    flexWrap: 'breakWord',
  },
  Link: {
    fontSize: '15px',
    fontFamily: '"Alegreya Sans", sans-serif',
    color: '#fa0171',
    marginLeft: '5px',
    '&:hover': {
      color: '#95025c',
    },
  },
}));

function StyledCheckbox(props) {
  const classes = checkboxUseStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color='default'
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'Weaviate console checkbox' }}
      {...props}
    />
  );
}

function SmallStyledCheckbox(props) {
  const classes = smallerCheckboxUseStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color='default'
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'Weaviate console checkbox' }}
      {...props}
    />
  );
}

export const MyCheckboxComponent = ({
  value,
  onChange,
  label,
  helperText,
  options,
  state,
  row,
  helperTextLink,
  smallCheckbox,
}) => {
  const classes = smallCheckbox
    ? smallerCheckboxUseStyles()
    : checkboxUseStyles();
  return (
    <FormControl
      component='fieldset'
      className={smallCheckbox ? classes.checkboxFormControl : null}
    >
      <FormGroup row={row}>
        {options ? (
          options.map((o, idx) => (
            <FormControlLabel
              className={classes.FormControlLabel}
              key={idx}
              control={
                smallCheckbox ? (
                  <SmallStyledCheckbox
                    checked={value === 'true' ? true : false}
                    onChange={onChange}
                    name={o.name}
                  />
                ) : (
                  <StyledCheckbox
                    checked={value === 'true' ? true : false}
                    onChange={onChange}
                    name={o.name}
                  />
                )
              }
              label={
                helperText ? (
                  <p
                    style={{
                      margin: '0 10px 0 0',
                      color: state.theme === 'dark' ? '#fff' : '#00152b',
                      fontFamily: '"Alegreya Sans", sans-serif',
                      fontSize: '15px',
                    }}
                  >
                    {helperText}{' '}
                    {helperTextLink ? (
                      <a
                        className={classes.Link}
                        rel='noreferrer'
                        target='_blank'
                        href={helperTextLink}
                      >
                        LEARN MORE
                      </a>
                    ) : null}
                  </p>
                ) : null
              }
            />
          ))
        ) : (
          <FormControlLabel
            className={classes.FormControlLabel}
            control={
              <StyledCheckbox
                checked={value}
                onChange={onChange}
                name={label}
              />
            }
            label={label}
          />
        )}
      </FormGroup>
    </FormControl>
  );
};

//ACCORDION
export const CustomAccordion = withStyles({
  root: {
    background: 'transparent',
    backgroundColor: 'transparent',
  },
})(Accordion);

// BUTTON
export const PrimaryButton = withStyles((theme) => ({
  root: {
    color: '#fff',
    fontFamily: '"Alegreya Sans", sans-serif',
    marginRight: '10px',
    fontSize: '23px',
    width: '190px',
    backgroundColor: '#fa0171',
    '&:hover': {
      backgroundColor: '#95025c',
    },
  },
}))(Button);

export const SecondaryButton = withStyles((theme) => ({
  root: {
    color: '#fff',
    fontFamily: '"Alegreya Sans", sans-serif',
    marginLeft: '10px',
    fontSize: '23px',
    width: '190px',
    backgroundColor: '#ababab',
    '&:hover': {
      backgroundColor: '#848484',
    },
  },
}))(Button);

export const TertiaryButton = withStyles((theme) => ({
  root: {
    color: '#38d611',
    textTransform: 'capitalize',
    border: '1px solid #38d611',
    fontFamily: '"Alegreya Sans", sans-serif',
    marginLeft: '10px',
    fontSize: '18px',
    width: '80px',
    height: '30px',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#38d611',
      color: '#fff',
      border: '1px solid #fff',
    },
  },
}))(Button);

//circled loader with label inside with percentage
export const CustomCircularLoader = (props) => {
  return (
    <Box position='relative' display='flex'>
      <CircularProgress style={{ color: '#38d611' }} {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <div
          style={{
            color: props.state.theme === 'dark' ? '#fff' : '#00152b',
            fontFamily: '"Alegreya Sans", sans-serif',
            fontSize: '14px',
          }}
        >{`${Math.ceil(props.value)}%`}</div>
      </Box>
    </Box>
  );
};

CustomCircularLoader.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  //Custom tabs with content dynamically changing
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export const CustomTabsWithContent = ({
  state,
  value,
  setValue,
  tabs,
  panels,
}) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: state.theme === 'dark' ? 'transparent' : '#fff',
      width: '85%',
      marginBottom: '50px',
      border: state.theme === 'dark' ? '1px solid #122742' : 'none',
    },
    tab: {
      fontFamily: '"Alegreya Sans", sans-serif',
      boxShadow: 'none',
      borderBottom: 'none',
      fontSize: '18px',
      width: 'fit-content',
      textTransform: 'capitalize',
      color: state.theme === 'dark' ? '#fff' : '#00152b',

      '&.Mui-selected': {
        color: state.theme === 'dark' ? '#fff' : '#00152b',
      },
      '&.MuiTabs-indicator': {
        color: '#fa0171 !important',
      },
    },
    appBar: {
      width: 'fit-content',
      background: state.theme === 'dark' ? 'transparent' : '#fff',
      boxShadow: 'none',
    },
  }));

  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper className={classes.root}>
      <AppBar position='static' className={classes.appBar}>
        <Tabs value={value} onChange={handleChange}>
          {tabs.map((tab, idx) => (
            <Tab
              key={idx}
              className={classes.tab}
              label={tab.content}
              {...a11yProps(tab.index)}
            />
          ))}
        </Tabs>
      </AppBar>
      {panels.map((panel, idx) => (
        <TabPanel value={value} key={idx} index={panel.index}>
          {panel.content}
        </TabPanel>
      ))}
    </Paper>
  );
};

//Custom tabs without content. Only sets state
export const CustomTabsWithoutContent = ({ value, setValue, state, tabs }) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: state.theme === 'dark' ? 'transparent' : '#fff',
      width: 'fit-content',
      marginBottom: '50px',
      border: state.theme === 'dark' ? '1px solid #122742' : 'none',
      display: 'flex',
      '@media(max-width: 725px)': {
        // width: "500px",
      },
    },
    tab: {
      fontFamily: '"Alegreya Sans", sans-serif',
      borderBottom: 'none',
      boxShadow: 'none',
      fontSize: '17px',
      width: 'fit-content',
      textTransform: 'capitalize',
      color: state.theme === 'dark' ? '#fff' : '#00152b',

      '&.Mui-selected': {
        color: state.theme === 'dark' ? '#fff' : '#00152b',
      },
      '&.MuiTabs-indicator': {
        color: '#fa0171 !important',
      },

      '@media(max-width: 725px)': {
        // maxWidth: "30px",
        // fontSize: "15px",
      },
    },
    appBar: {
      width: '100%',
      background: state.theme === 'dark' ? 'transparent' : '#fff',
      boxShadow: 'none',
    },
    tabs: {
      '@media(max-width: 725px)': {
        // width: "500px",
      },
    },
  }));

  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper square className={classes.root}>
      <AppBar position='static' className={classes.appBar}>
        <Tabs
          variant='fullWidth'
          value={value}
          onChange={handleChange}
          aria-label='weaviate metrics tabs'
          className={classes.tabs}
        >
          {tabs.map((tab, idx) => (
            <Tab key={idx} label={tab} className={classes.tab} value={tab} />
          ))}
        </Tabs>
      </AppBar>
    </Paper>
  );
};

//Empty state cards

export const CustomEmptyStateCard = ({
  title,
  text,
  buttonText,
  onClick,
  img,
  state,
}) => {
  const emptyStateCardUseStyles = makeStyles({
    root: {
      width: 500,
      fontFamily: '"Alegreya Sans", sans-serif',
    },
    media: {
      height: 570,
      width: 500,
    },
    text: {
      fontFamily: '"Alegreya Sans", sans-serif',
    },
  });

  const classes = emptyStateCardUseStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia className={classes.media} image={img} title={title} />
        <CardContent>
          <Typography
            gutterBottom
            variant='h5'
            component='h2'
            className={classes.text}
          >
            {title}
          </Typography>
          <Typography
            variant='body2'
            color='textSecondary'
            component='p'
            className={classes.text}
          >
            {text}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size='small' onClick={onClick} className={classes.text}>
          {buttonText}
        </Button>
      </CardActions>
    </Card>
  );
};
